"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconQuestionMark = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M45.27 10.52A15.08 15.08 0 0 0 20 23.17a2.5 2.5 0 1 0 5-.54 10.09 10.09 0 1 1 17.16 6.15l-4.71 4.71a21.43 21.43 0 0 0-6.35 15.26V54a2.5 2.5 0 1 0 5 0v-5.25A16.47 16.47 0 0 1 41 37l4.71-4.71a15.15 15.15 0 0 0-.38-21.8z"
  }), _react["default"].createElement("circle", {
    cx: "33.59",
    cy: "62.28",
    r: "2.75"
  })),
  height: undefined,
  width: undefined
});
IconQuestionMark.displayName = 'IconQuestionMark';
var _default = IconQuestionMark;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/question-mark.js
// module id = 581
// module chunks = 0